var _circle, _circle2, _circle3, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSisteringFrown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 173,
    viewBox: "0 0 173 173",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 86.5,
    cy: 86.5,
    r: 81.5,
    stroke: "#7600E3",
    strokeWidth: 10
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 72.5,
    r: 7.5,
    fill: "#7600E3"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 109.5,
    cy: 72.5,
    r: 7.5,
    fill: "#7600E3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115.131 123.294C116.972 122.397 117.754 120.165 116.667 118.429C113.874 113.967 110.1 110.178 105.615 107.361C100.08 103.884 93.6814 102.027 87.145 102C80.6086 101.973 74.1953 103.777 68.6313 107.208C64.1229 109.987 60.3181 113.745 57.4878 118.184C56.387 119.911 57.15 122.15 58.9832 123.062V123.062C60.8165 123.974 63.0224 123.209 64.1719 121.514C66.3518 118.301 69.1939 115.572 72.5229 113.519C76.9081 110.816 81.9627 109.394 87.1143 109.415C92.2659 109.437 97.3086 110.9 101.671 113.64C104.983 115.72 107.802 118.473 109.956 121.704C111.091 123.408 113.291 124.191 115.131 123.294V123.294Z",
    fill: "#7600E3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSisteringFrown);
export default __webpack_public_path__ + "static/media/Sistering_frown.bcee6cf2.svg";
export { ForwardRef as ReactComponent };